import { useState } from 'react';
import { useActionsCommandPalette } from '@atlassian/jira-command-palette/src/controllers/command-palette/index.tsx';
import { COMMAND_PALETTE_REGISTRY } from '../../common/constants/registry/index.tsx';

export const useCommandPaletteRegistry = () => {
	const { setRegistry } = useActionsCommandPalette();
	useState(() => {
		setRegistry(COMMAND_PALETTE_REGISTRY);
	});
};
